(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sya-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const revealCurrentCategory = () => {
      if (!mobileQuery.matches) return;
      document.querySelectorAll('.sya-collection-intro__families').forEach((rail) => {
        const current = rail.querySelector('[aria-current="page"]');
        if (!current) return;
        const railBounds = rail.getBoundingClientRect();
        const currentBounds = current.getBoundingClientRect();
        rail.scrollTo({
          left: rail.scrollLeft + currentBounds.left - railBounds.left - (rail.clientWidth - currentBounds.width) / 2,
          behavior: 'auto',
        });
      });
    };
    const scheduleReveal = () => requestAnimationFrame(revealCurrentCategory);
    scheduleReveal();
    window.addEventListener('pageshow', scheduleReveal);
    mobileQuery.addEventListener('change', scheduleReveal);
    document.addEventListener('shopify:section:load', scheduleReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sya-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sya-event-inquiry')) {
    customElements.define('sya-event-inquiry', class extends HTMLElement {
      connectedCallback() {
        this.listenerController?.abort();
        const form = this.querySelector('form');
        if (!form) return;
        this.listenerController = new AbortController();
        const { signal } = this.listenerController;
        const storageKey = `sya-event-inquiry:v2:${form.id}`;
        const lifetime = 30 * 60 * 1000;
        const success = this.querySelector('[data-sya-form-success]');
        const errors = this.querySelector('[data-sya-form-errors]');
        const fields = Array.from(form.elements).filter((field) =>
          field.name?.startsWith('contact[') && !field.disabled &&
          field.matches('input:not([type="hidden"]):not([type="password"]):not([type="file"]), select, textarea')
        );
        const occasionField = form.querySelector('select[name="contact[Tipo de evento]"]');
        const optional = this.querySelector('.sya-events__optional');
        let savedAt = 0;
        let dirty = false;
        const clearDraft = () => {
          try { sessionStorage.removeItem(storageKey); } catch {}
        };
        const selectOccasion = (occasionId) => {
          if (!occasionField) return false;
          const option = Array.from(occasionField.options).find((item) => item.dataset.syaOccasionId === occasionId);
          if (!option) return false;
          occasionField.value = option.value;
          return true;
        };
        const saveDraft = () => {
          if (success || !dirty) return;
          const now = Date.now();
          if (savedAt && now - savedAt >= lifetime) {
            clearDraft();
            return;
          }
          if (!savedAt) savedAt = now;
          const values = Object.fromEntries(fields
            .filter((field) => field !== occasionField)
            .map((field) => [field.name, field.value]));
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({
              savedAt,
              values,
              occasionId: occasionField?.selectedOptions[0]?.dataset.syaOccasionId || '',
              optionalOpen: Boolean(optional?.open)
            }));
          } catch {}
        };
        if (success) {
          clearDraft();
        } else {
          try {
            const saved = sessionStorage.getItem(storageKey);
            if (saved) {
              const draft = JSON.parse(saved);
              const age = Date.now() - draft.savedAt;
              if (Number.isFinite(draft.savedAt) && age >= 0 && age < lifetime && draft.values && typeof draft.values === 'object') {
                savedAt = draft.savedAt;
                fields.filter((field) => field !== occasionField).forEach((field) => {
                  const value = draft.values[field.name];
                  if (typeof value !== 'string') return;
                  if (field instanceof HTMLSelectElement && !Array.from(field.options).some((option) => option.value === value)) return;
                  field.value = field.maxLength > 0 ? value.slice(0, field.maxLength) : value;
                });
                selectOccasion(draft.occasionId);
                if (optional) optional.open = Boolean(draft.optionalOpen) || Array.from(optional.querySelectorAll('input')).some((field) => field.value.trim());
                dirty = true;
              } else clearDraft();
            }
          } catch { clearDraft(); }
        }
        const disclosure = this.closest('.sya-events__disclosure');
        const reveal = (target = this, focus = false) => {
          let ancestor = target.parentElement;
          while (ancestor) {
            if (ancestor instanceof HTMLDetailsElement) ancestor.open = true;
            ancestor = ancestor.parentElement;
          }
          if (focus) requestAnimationFrame(() => {
            target.focus({ preventScroll: true });
            target.scrollIntoView({ block: 'start', behavior: 'instant' });
          });
        };
        if (disclosure) {
          const summary = disclosure.querySelector('summary');
          const section = this.closest('.sya-events');
          const targetIds = new Set([section.id, this.id, form.id]);
          const revealHash = () => {
            const hash = window.location.hash.slice(1);
            const target = document.getElementById(hash);
            if (targetIds.has(hash) || (target && this.contains(target))) {
              const focusTarget = target && this.contains(target) && target.matches('input, select, textarea, button, a[href], [tabindex]') ? target : this;
              reveal(focusTarget, true);
            }
          };
          window.addEventListener('hashchange', revealHash, { signal });
          window.addEventListener('pageshow', revealHash, { signal });
          document.addEventListener('click', (event) => {
            const link = event.target.closest('a[href]');
            if (!link) return;
            const url = new URL(link.href, window.location.href);
            if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
            if (targetIds.has(url.hash.slice(1))) reveal(this, true);
          }, { signal });
          disclosure.addEventListener('toggle', () => {
            if (!disclosure.open && this.contains(document.activeElement)) summary?.focus();
          }, { signal });
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && disclosure.open && !event.defaultPrevented) {
              event.preventDefault();
              disclosure.open = false;
              summary?.focus();
            }
          }, { signal });
          if (!success && !errors) revealHash();
        }
        if (success || errors) reveal(success || errors, true);
        const markDirty = (event) => {
          if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
          const now = Date.now();
          if (savedAt && now - savedAt >= lifetime) {
            clearDraft();
            savedAt = now;
          }
          dirty = true;
        };
        form.addEventListener('input', markDirty, { signal });
        form.addEventListener('change', markDirty, { signal });
        form.addEventListener('invalid', (event) => {
          const field = event.target;
          reveal(field);
          if (typeof field.setCustomValidity === 'function') {
            field.setCustomValidity('');
            const message = field.validity.valueMissing
              ? form.dataset.syaRequiredMessage
              : field.type === 'email' && field.validity.typeMismatch
                ? form.dataset.syaEmailMessage
                : !field.validity.valid ? form.dataset.syaInvalidMessage : '';
            if (message) field.setCustomValidity(message);
          }
          const details = field.closest('.sya-events__optional');
          if (details) details.open = true;
        }, { capture: true, signal });
        form.addEventListener('submit', () => { dirty = true; saveDraft(); }, { signal });
        window.addEventListener('pagehide', saveDraft, { signal });
        document.addEventListener('sya:language-will-change', saveDraft, { signal });
        this.closest('.sya-events')?.addEventListener('click', (event) => {
          const target = event.target.closest('[data-sya-occasion]');
          if (!target || !selectOccasion(target.dataset.syaOccasion)) return;
          event.preventDefault();
          dirty = true;
          occasionField.dispatchEvent(new Event('change', { bubbles: true }));
          reveal(this);
          this.focus({ preventScroll: true });
          this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
      }

      disconnectedCallback() {
        this.listenerController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
